
<template>

    <section class="software-keys">
        <div class="panel">
            <div class="panel-heading"><h2>Your Software Keys</h2></div>
            <div class="panel-body">
                <table class="keys table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Program</th>
                            <th>Term</th>
                            <th>Key</th>
                        </tr>
                    </thead>

                    <tbody v-if="keys">
                        <tr v-for="key in keys">
                            <td>
                                <h5>
                                    <img :src="key.program.icon">
                                    {{key.program.name}}
                                </h5>
                            </td>
                            <td>
                                {{key.semester.startDate | monthAndYear}}
                            </td>
                            <td>
                                <span v-if="key.software_key">
                                    <b>{{key.software_key.key}}</b>
                                </span>
                                <span v-else>On Order</span>
                            </td>
                        </tr>
                    </tbody>
                  </table>
            </div>

        </div>

    </section>

</template>

<script>

import software from '../services/software';

export default {
    data() {
        return {
            keys:null
        }
    },
    components: {

    },
    mounted() {
        this.getKeys();
    },
    methods: {
        getKeys() {

            software.getKeys(this).then((response) => {
                this.keys = response.data.keys.sort((a,b)=> { return new Date(b.semester.startDate) - new Date(a.semester.startDate)});
            });
        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>

.keys {
    img {
        width:60px;
        height:auto;
        margin-right:1rem;
    }
    td {
        vertical-align: middle;
    }

}
</style>



// WEBPACK FOOTER //
// SoftwareKeys.vue?2388bf12